import { render, staticRenderFns } from "./VideoShow.vue?vue&type=template&id=d948dd40&scoped=true&"
import script from "./VideoShow.vue?vue&type=script&lang=ts&"
export * from "./VideoShow.vue?vue&type=script&lang=ts&"
import style0 from "./VideoShow.vue?vue&type=style&index=0&id=d948dd40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d948dd40",
  null
  
)

export default component.exports